export default "__VITE_ASSET__Dv81LWXx__"